import { render } from "./Chatbot.vue?vue&type=template&id=2b46043c"
import script from "./Chatbot.vue?vue&type=script&lang=js"
export * from "./Chatbot.vue?vue&type=script&lang=js"

import "./Chatbot.vue?vue&type=style&index=0&id=2b46043c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__